<template>
    <div>
        <section class="user_profile inner_pages">
            <div class="container"> 
                <div class="row">
                    <div class="col-md-3 col-sm-3">
                        <div class="profile_nav">
                            <ul>
                                <li class="active">
                                    <a href="/mi_perfil"
                                        >Mi perfil</a
                                    >
                                </li>
                                <li>
                                    <a href="/mis_retomas">Mis Retomas</a>
                                </li>
                                <li>
                                    <a href="/reportar_vehiculo"
                                        >Reportar Vehículo</a
                                    >
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-8">
                        <div class="profile_wrap">
                            <h5 class="uppercase underline">
                                AJUSTES GENERALES
                            </h5>
                            <form action="#" method="get">
                                <div class="form-group">
                                    <label class="control-label"
                                        >Nombre</label
                                    >
                                    <input
                                        class="form-control white_bg"
                                        id="fullname"
                                        type="text"
                                    />
                                </div>
                                <div class="form-group">
                                    <label class="control-label"
                                        >Apellidos</label
                                    >
                                    <input
                                        class="form-control white_bg"
                                        id="fulllast"
                                        type="text"
                                    />
                                </div>
                                <div class="form-group">
                                    <label class="control-label"
                                        >Correo Electronico</label
                                    >
                                    <input
                                        class="form-control white_bg"
                                        id="email"
                                        type="email"
                                    />
                                </div>
                                <div class="form-group">
                                    <label class="control-label"
                                        >Celular:</label
                                    >
                                    <input
                                        class="form-control white_bg"
                                        id="phone-number"
                                        type="text"
                                    />
                                </div>
                                
                                <div class="form-group">
                                    <label class="control-label"
                                        >Dirección</label
                                    >
                                    <input
                                        class="form-control white_bg"
                                        id="adress"
                                        type="text"
                                    />
                                </div>
                                <div class="form-group">
                                    <label class="control-label">Ubicación</label>
                                    <input
                                        class="form-control white_bg"
                                        id="city"
                                        type="text"
                                    />
                                </div>
                                <div class="gray-bg field-title">
                                    <h6>Actualizar Contraseña</h6>
                                </div>
                                <div class="form-group">
                                    <label class="control-label"
                                        >Contraseña</label
                                    >
                                    <input
                                        class="form-control white_bg"
                                        id="password"
                                        type="password"
                                    />
                                </div>
                                <div class="form-group">
                                    <label class="control-label"
                                        >Confirmar Contraseña</label
                                    >
                                    <input
                                        class="form-control white_bg"
                                        id="c-password"
                                        type="password"
                                    />
                                </div>
                                <div class="form-group">
                                    <button type="submit" class="btn">
                                       Actualizar
                                        <span class="angle_arrow"
                                            ><i
                                                class="fa fa-angle-right"
                                                aria-hidden="true"
                                            ></i
                                        ></span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
